export const API_ENDPOINTS = {
  GET_DATA: "/users",
  POST_DATA: "/users",
  PUT_DATA: "/users/",
  DELETE_DATA: "/users/",
};

export const delayTime = 1000;

export const REACT_APP_APPLICATION_ENVIRONMENT = "DEVELOPMENT";
// export const REACT_APP_APPLICATION_ENVIRONMENT = "PRODUCTION";
// export const REACT_APP_APPLICATION_ENVIRONMENT = "STAGING";
export const REACT_APP_DEVELOPMENT_URL =
  // "https://38fb-116-73-63-161.ngrok-free.app/v1";
// "http://localhost:3000/v1";
"https://cypher-hms-backend.onrender.com/v1"

export const REACT_APP_STAGING_URL = "https://cypher-hms-backend.onrender.com/v1";
export const REACT_APP_PRODUCTION_URL = "https://cypher-hms-backend.onrender.com/v1";


export const ENCRYPTION_KEY = "hms_secret_key_789";

export const GET_GUEST_LIST_REQUEST = "GET_GUEST_LIST_REQUEST";
export const GET_GUEST_LIST_SUCCESS = "GET_GUEST_LIST_SUCCESS";
export const GET_GUEST_LIST_FAILURE = "GET_GUEST_LIST_FAILURE";

export const DELETE_API_REQUEST = "DELETE_API_REQUEST";
export const DELETE_API_SUCCESS = "DELETE_API_SUCCESS";
export const DELETE_API_FAILURE = "DELETE_API_FAILURE";

export const GET_API_REQUEST = "GET_API_REQUEST";
export const GET_API_SUCCESS = "GET_API_SUCCESS";
export const GET_API_FAILURE = "GET_API_FAILURE";

export const PUT_API_SUCCESS = "PUT_API_SUCCESS";
export const PUT_API_FAILURE = "PUT_API_FAILURE";
export const PUT_API_REQUEST = "PUT_API_REQUEST";

export const POST_API_REQUEST = "POST_API_REQUEST";
export const POST_API_SUCCESS = "POST_API_SUCCESS";
export const POST_API_FAILURE = "POST_API_FAILURE";

export const PATCH_API_REQUEST = "PATCH_API_REQUEST";
export const PATCH_API_SUCCESS = "PATCH_API_SUCCESS";
export const PATCH_API_FAILURE = "PATCH_API_FAILURE";

export const GET_ROOM_TYPE_REQUEST = "GET_ROOM_TYPE_REQUEST";
export const GET_ROOM_TYPE_SUCCESS = "GET_ROOM_TYPE_SUCCESS";
export const GET_ROOM_TYPE_FAILURE = "GET_ROOM_TYPE_FAILURE";

export const GET_ROOM_TYPE_NAME_REQUEST = "GET_ROOM_TYPE_NAME_REQUEST";
export const GET_ROOM_TYPE_NAME_SUCCESS = "GET_ROOM_TYPE_NAME_SUCCESS";
export const GET_ROOM_TYPE_NAME_FAILURE = "GET_ROOM_TYPE_NAME_FAILURE";

export const POST_ROOM_TYPE_REQUEST = "POST_ROOM_TYPE_REQUEST";
export const POST_ROOM_TYPE_SUCCESS = "POST_ROOM_TYPE_SUCCESS";
export const POST_ROOM_TYPE_FAILURE = "POST_ROOM_TYPE_FAILURE";

export const GET_BYID_ROOM_TYPE_REQUEST = "GET_BYID_ROOM_TYPE_REQUEST";
export const GET_BYID_ROOM_TYPE_SUCCESS = "GET_BYID_ROOM_TYPE_SUCCESS";
export const GET_BYID_ROOM_TYPE_FAILURE = "GET_BYID_ROOM_TYPE_FAILURE";

export const DELETE_ROOM_TYPE_REQUEST = "DELETE_ROOM_TYPE_REQUEST";
export const DELETE_ROOM_TYPE_SUCCESS = "DELETE_ROOM_TYPE_SUCCESS";
export const DELETE_ROOM_TYPE_FAILURE = "DELETE_ROOM_TYPE_FAILURE";

export const PATCH_ROOM_TYPE_REQUEST = "PATCH_ROOM_TYPE_REQUEST";
export const PATCH_ROOM_TYPE_SUCCESS = "PATCH_ROOM_TYPE_SUCCESS";
export const PATCH_ROOM_TYPE_FAILURE = "PATCH_ROOM_TYPE_FAILURE";
export const RESET_ROOM_TYPE_FLAGS = "RESET_ROOM_TYPE_FLAGS";

export const GET_THEME_MODE_REQUEST = "GET_THEME_MODE_REQUEST";
export const GET_THEME_MODE_SUCCESS = "GET_THEME_MODE_SUCCESS";
export const GET_THEME_MODE_FAILURE = "GET_THEME_MODE_FAILURE";

export const GET_AMENITY_REQUEST = "GET_AMENITY_REQUEST";
export const GET_AMENITY_SUCCESS = "GET_AMENITY_SUCCESS";
export const GET_AMENITY_FAILURE = "GET_AMENITY_FAILURE";

export const POST_AMENITY_REQUEST = "POST_AMENITY_REQUEST";
export const POST_AMENITY_SUCCESS = "POST_AMENITY_SUCCESS";
export const POST_AMENITY_FAILURE = "POST_AMENITY_FAILURE";

export const PUT_AMENITY_REQUEST = "PUT_AMENITY_REQUEST";
export const PUT_AMENITY_SUCCESS = "PUT_AMENITY_SUCCESS";
export const PUT_AMENITY_FAILURE = "PUT_AMENITY_FAILURE";

export const DELETE_AMENITY_REQUEST = "DELETE_AMENITY_REQUEST";
export const DELETE_AMENITY_SUCCESS = "DELETE_AMENITY_SUCCESS";
export const DELETE_AMENITY_FAILURE = "DELETE_AMENITY_FAILURE";

export const GET_OFFERS_LIST_REQUEST = "GET_OFFERS_LIST_REQUEST";
export const GET_OFFERS_LIST_SUCCESS = "GET_OFFERS_LIST_SUCCESS";
export const GET_OFFERS_LIST_FAILURE = "GET_OFFERS_LIST_FAILURE";

export const GET_ROOM_BOOKING_LIST_REQUEST = "GET_ROOM_BOOKING_LIST_REQUEST";
export const GET_ROOM_BOOKING_LIST_SUCCESS = "GET_ROOM_BOOKING_LIST_SUCCESS";
export const GET_ROOM_BOOKING_LIST_FAILURE = "GET_ROOM_BOOKING_LIST_FAILURE";

export const POST_ROOM_BOOKING_REQUEST = "POST_ROOM_BOOKING_REQUEST";
export const POST_ROOM_BOOKING_SUCCESS = "POST_ROOM_BOOKING_SUCCESS";
export const POST_ROOM_BOOKING_FAILURE = "POST_ROOM_BOOKING_FAILURE";

export const PUT_ROOM_REASSIGN_SUCCESS = "PUT_ROOM_REASSIGN_SUCCESS";
export const PUT_ROOM_REASSIGN_REQUEST = "PUT_ROOM_REASSIGN_REQUEST";
export const PUT_ROOM_REASSIGN_FAILURE = "PUT_ROOM_REASSIGN_FAILURE";

export const GET_BYID_ROOM_BOOKING_REQUEST = "GET_BYID_ROOM_BOOKING_REQUEST";
export const GET_BYID_ROOM_BOOKING_SUCCESS = "GET_BYID_ROOM_BOOKING_SUCCESS";
export const GET_BYID_ROOM_BOOKING_FAILURE = "GET_BYID_ROOM_BOOKING_FAILURE";

export const PATCH_ROOM_BOOKING_REQUEST = "PATCH_ROOM_BOOKING_REQUEST";
export const PATCH_ROOM_BOOKING_SUCCESS = "PATCH_ROOM_BOOKING_SUCCESS";
export const PATCH_ROOM_BOOKING_FAILURE = "PATCH_ROOM_BOOKING_FAILURE";

export const EXPORT_ROOM_BOOKING_SUCCESS = "EXPORT_ROOM_BOOKING_SUCCESS";
export const EXPORT_ROOM_BOOKING_REQUEST = "EXPORT_ROOM_BOOKING_REQUEST";
export const EXPORT_ROOM_BOOKING_FAILURE = "EXPORT_ROOM_BOOKING_FAILURE";
export const RESET_ROOM_BOOKING = "RESET_ROOM_BOOKING";

export const FETCH_ROOM_AVAILABILITY_REQUEST =
  "FETCH_ROOM_AVAILABILITY_REQUEST";
export const FETCH_ROOM_AVAILABILITY_SUCCESS =
  "FETCH_ROOM_AVAILABILITY_SUCCESS";
export const FETCH_ROOM_AVAILABILITY_FAILURE =
  "FETCH_ROOM_AVAILABILITY_FAILURE";

export const FETCH_ROOM_REQUEST = "FETCH_ROOM_REQUEST";
export const FETCH_ROOM_SUCCESS = "FETCH_ROOM_SUCCESS";
export const FETCH_ROOM_FAILURE = "FETCH_ROOM_FAILURE";

export const FETCH_RESERVATION_REQUEST = "FETCH_RESERVATION_REQUEST";
export const FETCH_RESERVATION_SUCCESS = "FETCH_RESERVATION_SUCCESS";
export const FETCH_RESERVATION_FAILURE = "FETCH_RESERVATION_FAILURE";

export const GET_ROOM_STATUS_REQUEST = "GET_ROOM_STATUS_REQUEST";
export const GET_ROOM_STATUS_SUCCESS = "GET_ROOM_STATUS_SUCCESS";
export const GET_ROOM_STATUS_FAILURE = "GET_ROOM_STATUS_FAILURE";

export const GET_ROOM_NUMBER_DETAIL_REQUEST = "GET_ROOM_NUMBER_DETAIL_REQUEST";
export const GET_ROOM_NUMBER_DETAIL_SUCCESS = "GET_ROOM_NUMBER_DETAIL_SUCCESS";
export const GET_ROOM_NUMBER_DETAIL_FAILURE = "GET_ROOM_NUMBER_DETAIL_FAILURE";
export const GET_ALL_RESERVATION_LIST_REQUEST =
  "GET_ALL_RESERVATION_LIST_REQUEST";
export const GET_ALL_RESERVATION_LIST_SUCCESS =
  "GET_ALL_RESERVATION_LIST_SUCCESS";
export const GET_ALL_RESERVATION_LIST_FAILURE =
  "GET_ALL_RESERVATION_LIST_FAILURE";

export const PUT_ROOM_BOOKING_DETAILS_SUCCESS =
  "PUT_ROOM_BOOKING_DETAILS_SUCCESS";
export const PUT_ROOM_BOOKING_DETAILS_REQUEST =
  "PUT_ROOM_BOOKING_DETAILS_REQUEST";
export const PUT_ROOM_BOOKING_DETAILS_FAILURE =
  "PUT_ROOM_BOOKING_DETAILS_FAILURE";

export const GET_ALL_ROOM_NUMBER_WITH_ID_SUCCESS =
  "GET_ALL_ROOM_NUMBER_WITH_ID_SUCCESS";
export const GET_ALL_ROOM_NUMBER_WITH_ID_REQUEST =
  "GET_ALL_ROOM_NUMBER_WITH_ID_REQUEST";
export const GET_ALL_ROOM_NUMBER_WITH_ID_FAILURE =
  "GET_ALL_ROOM_NUMBER_WITH_ID_FAILURE";

export const GET_ALL_ROOM_TYPE_WITH_ID_SUCCESS =
  "GET_ALL_ROOM_TYPE_WITH_ID_SUCCESS";
export const GET_ALL_ROOM_TYPE_WITH_ID_REQUEST =
  "GET_ALL_ROOM_TYPE_WITH_ID_REQUEST";
export const GET_ALL_ROOM_TYPE_WITH_ID_FAILURE =
  "GET_ALL_ROOM_TYPE_WITH_ID_FAILURE";

export const GET_GUEST_SEARCH_REQUEST = "GET_GUEST_SEARCH_REQUEST";
export const GET_GUEST_SEARCH_SUCCESS = "GET_GUEST_SEARCH_SUCCESS";
export const GET_GUEST_SEARCH_FAILURE = "GET_GUEST_SEARCH_FAILURE";

export const GET_ALL_BOOKING_LOGS_REQUEST = "GET_ALL_BOOKING_LOGS_REQUEST";
export const GET_ALL_BOOKING_LOGS_SUCCESS = "GET_ALL_BOOKING_LOG_SUCCESS";
export const GET_ALL_BOOKING_LOGS_FAILURE = "GET_ALL_BOOKING_LOG_FAILURE";

export const GET_RESERVATION_LIST_EXPORT_REQUEST =
  "GET_RESERVATION_LIST_EXPORT_REQUEST";
export const GET_RESERVATION_LIST_EXPORT_SUCCESS =
  "GET_RESERVATION_LIST_EXPORT_SUCCESS";
export const GET_RESERVATION_LIST_EXPORT_FAILURE =
  "GET_RESERVATION_LIST_EXPORT_FAILURE";

export const GET_ALL_RESTAURANT_CATEGORY_LIST_REQUEST =
  "GET_ALL_RESTAURANT_CATEGORY_LIST_REQUEST";

export const GET_ALL_RESTAURANT_CATEGORY_LIST_SUCCESS =
  "GET_ALL_RESTAURANT_CATEGORY_LIST_SUCCESS";

export const GET_ALL_RESTAURANT_CATEGORY_LIST_FAILURE =
  "GET_ALL_RESTAURANT_CATEGORY_LIST_FAILURE";

export const POST_RESTAURANT_CATEGORY_REQUEST =
  "POST_RESTAURANT_CATEGORY_REQUEST";

export const POST_RESTAURANT_CATEGORY_SUCCESS =
  "POST_RESTAURANT_CATEGORY_SUCCESS";

export const POST_RESTAURANT_CATEGORY_FAILURE =
  "POST_RESTAURANT_CATEGORY_FAILURE";

export const PUT_RESTAURANT_CATEGORY_REQUEST =
  "PUT_RESTAURANT_CATEGORY_REQUEST";

export const PUT_RESTAURANT_CATEGORY_SUCCESS =
  "PUT_RESTAURANT_CATEGORY_SUCCESS";

export const PUT_RESTAURANT_CATEGORY_FAILURE =
  "PUT_RESTAURANT_CATEGORY_FAILURE";

export const GET_TABLE_LIST_REQUEST = "GET_TABLE_LIST_REQUEST";
export const GET_TABLE_LIST_SUCCESS = "GET_TABLE_LIST_SUCCESS";
export const GET_TABLE_LIST_FAILURE = "GET_TABLE_LIST_FAILURE";

export const POST_TABLE_LIST_REQUEST = "POST_TABLE_LIST_REQUEST";
export const POST_TABLE_LIST_SUCCESS = "POST_TABLE_LIST_SUCCESS";
export const POST_TABLE_LIST_FAILURE = "POST_TABLE_LIST_FAILURE";

export const GET_BYID_TABLE_LIST_REQUEST = "GET_BYID_TABLE_LIST_REQUEST";
export const GET_BYID_TABLE_LIST_SUCCESS = "GET_BYID_TABLE_LIST_SUCCESS";
export const GET_BYID_TABLE_LIST_FAILURE = "GET_BYID_TABLE_LIST_FAILURE";

export const PUT_TABLE_LIST_REQUEST = "PUT_TABLE_LIST_REQUEST";
export const PUT_TABLE_LIST_SUCCESS = "PUT_TABLE_LIST_SUCCESS";
export const PUT_TABLE_LIST_FAILURE = "PUT_TABLE_LIST_FAILURE";

export const DELETE_TABLE_LIST_REQUEST = "DELETE_TABLE_LIST_REQUEST";
export const DELETE_TABLE_LIST_SUCCESS = "DELETE_TABLE_LIST_SUCCESS";
export const DELETE_TABLE_LIST_FAILURE = "DELETE_TABLE_LIST_FAILURE";
export const RESET_TABLE_FLAGS = "RESET_TABLE_FLAGS";

export const GET_TABLE_RESERVATION_LIST_REQUEST =
  "GET_TABLE_RESERVATION_LIST_REQUEST";
export const GET_TABLE_RESERVATION_LIST_SUCCESS =
  "GET_TABLE_RESERVATION_LIST_SUCCESS";
export const GET_TABLE_RESERVATION_LIST_FAILURE =
  "GET_TABLE_RESERVATION_LIST_FAILURE";

export const POST_TABLE_RESERVATION_LIST_REQUEST =
  "POST_TABLE_RESERVATION_LIST_REQUEST";
export const POST_TABLE_RESERVATION_LIST_SUCCESS =
  "POST_TABLE_RESERVATION_LIST_SUCCESS";
export const POST_TABLE_RESERVATION_LIST_FAILURE =
  "POST_TABLE_RESERVATION_LIST_FAILURE";

export const GET_BYID_TABLE_RESERVATION_LIST_REQUEST =
  "GET_BYID_TABLE_RESERVATION_LIST_REQUEST";
export const GET_BYID_TABLE_RESERVATION_LIST_SUCCESS =
  "GET_BYID_TABLE_RESERVATION_LIST_SUCCESS";
export const GET_BYID_TABLE_RESERVATION_LIST_FAILURE =
  "GET_BYID_TABLE_RESERVATION_LIST_FAILURE";

export const PUT_TABLE_RESERVATION_LIST_REQUEST =
  "PUT_TABLE_RESERVATION_LIST_REQUEST";
export const PUT_TABLE_RESERVATION_LIST_SUCCESS =
  "PUT_TABLE_RESERVATION_LIST_SUCCESS";
export const PUT_TABLE_RESERVATION_LIST_FAILURE =
  "PUT_TABLE_RESERVATION_LIST_FAILURE";

export const DELETE_TABLE_RESERVATION_LIST_REQUEST =
  "DELETE_TABLE_RESERVATION_LIST_REQUEST";
export const DELETE_TABLE_RESERVATION_LIST_SUCCESS =
  "DELETE_TABLE_RESERVATION_LIST_SUCCESS";
export const DELETE_TABLE_RESERVATION_LIST_FAILURE =
  "DELETE_TABLE_RESERVATION_LIST_FAILURE";

export const DELETE_RESTAURANT_CATEGORY_REQUEST =
  "DELETE_RESTAURANT_CATEGORY_REQUEST";

export const DELETE_RESTAURANT_CATEGORY_SUCCESS =
  "DELETE_RESTAURANT_CATEGORY_SUCCESS";

export const DELETE_RESTAURANT_CATEGORY_FAILURE =
  "DELETE_RESTAURANT_CATEGORY_FAILURE";

export const GET_ALL_RESTAURANT_SUB_CATEGORY_LIST_REQUEST =
  "GET_ALL_RESTAURANT_SUB_CATEGORY_LIST_REQUEST";

export const GET_ALL_RESTAURANT_SUB_CATEGORY_LIST_SUCCESS =
  "GET_ALL_RESTAURANT_SUB_CATEGORY_LIST_SUCCESS";

export const GET_ALL_RESTAURANT_SUB_CATEGORY_LIST_FAILURE =
  "GET_ALL_RESTAURANT_SUB_CATEGORY_LIST_FAILURE";

export const POST_RESTAURANT_SUB_CATEGORY_REQUEST =
  "POST_RESTAURANT_SUB_CATEGORY_REQUEST";

export const POST_RESTAURANT_SUB_CATEGORY_SUCCESS =
  "POST_RESTAURANT_SUB_CATEGORY_SUCCESS";

export const POST_RESTAURANT_SUB_CATEGORY_FAILURE =
  "POST_RESTAURANT_SUB_CATEGORY_FAILURE";

export const PUT_RESTAURANT_SUB_CATEGORY_REQUEST =
  "PUT_RESTAURANT_SUB_CATEGORY_REQUEST";

export const PUT_RESTAURANT_SUB_CATEGORY_SUCCESS =
  "PUT_RESTAURANT_SUB_CATEGORY_SUCCESS";

export const PUT_RESTAURANT_SUB_CATEGORY_FAILURE =
  "PUT_RESTAURANT_SUB_CATEGORY_FAILURE";

export const DELETE_RESTAURANT_SUB_CATEGORY_REQUEST =
  "DELETE_RESTAURANT_SUB_CATEGORY_REQUEST";

export const DELETE_RESTAURANT_SUB_CATEGORY_SUCCESS =
  "DELETE_RESTAURANT_SUB_CATEGORY_SUCCESS";

export const DELETE_RESTAURANT_SUB_CATEGORY_FAILURE =
  "DELETE_RESTAURANT_SUB_CATEGORY_FAILURE";

export const GET_ALL_RESTAURANT_VARIANT_LIST_REQUEST =
  "GET_ALL_RESTAURANT_VARIANT_LIST_REQUEST";

export const GET_ALL_RESTAURANT_VARIANT_LIST_SUCCESS =
  "GET_ALL_RESTAURANT_VARIANT_LIST_SUCCESS";

export const GET_ALL_RESTAURANT_VARIANT_LIST_FAILURE =
  "GET_ALL_RESTAURANT_VARIANT_LIST_FAILURE";

export const POST_RESTAURANT_VARIANT_REQUEST =
  "POST_RESTAURANT_VARIANT_REQUEST";

export const POST_RESTAURANT_VARIANT_SUCCESS =
  "POST_RESTAURANT_VARIANT_SUCCESS";

export const POST_RESTAURANT_VARIANT_FAILURE =
  "POST_RESTAURANT_VARIANT_FAILURE";

export const PUT_RESTAURANT_VARIANT_REQUEST = "PUT_RESTAURANT_VARIANT_REQUEST";

export const PUT_RESTAURANT_VARIANT_SUCCESS = "PUT_RESTAURANT_VARIANT_SUCCESS";

export const PUT_RESTAURANT_VARIANT_FAILURE = "PUT_RESTAURANT_VARIANT_FAILURE";

export const DELETE_RESTAURANT_VARIANT_REQUEST =
  "DELETE_RESTAURANT_VARIANT_REQUEST";

export const DELETE_RESTAURANT_VARIANT_SUCCESS =
  "DELETE_RESTAURANT_VARIANT_SUCCESS";

export const DELETE_RESTAURANT_VARIANT_FAILURE =
  "DELETE_RESTAURANT_VARIANT_FAILURE";
export const GET_ORDER_LIST_SUCCESS = "GET_ORDER_LIST_SUCCESS";
export const GET_ORDER_LIST_REQUEST = "GET_ORDER_LIST_REQUEST";
export const GET_ORDER_LIST_FAILURE = "GET_ORDER_LIST_FAILURE";

export const POST_ORDER_LIST_REQUEST = "POST_ORDER_LIST_REQUEST";
export const POST_ORDER_LIST_SUCCESS = "POST_ORDER_LIST_SUCCESS";
export const POST_ORDER_LIST_FAILURE = "POST_ORDER_LIST_FAILURE";

export const PUT_ORDER_LIST_REQUEST = "PUT_ORDER_LIST_REQUEST";
export const PUT_ORDER_LIST_SUCCESS = "PUT_ORDER_LIST_SUCCESS";
export const PUT_ORDER_LIST_FAILURE = "PUT_ORDER_LIST_FAILURE";

export const DELETE_ORDER_LIST_REQUEST = "DELETE_ORDER_LIST_REQUEST";
export const DELETE_ORDER_LIST_SUCCESS = "DELETE_ORDER_LIST_SUCCESS";
export const DELETE_ORDER_LIST_FAILURE = "DELETE_ORDER_LIST_FAILURE";

// Departments
export const GET_ALL_DEPARTMENT_LIST_REQUEST =
  "GET_ALL_DEPARTMENT_LIST_REQUEST";

export const GET_ALL_DEPARTMENT_LIST_SUCCESS =
  "GET_ALL_DEPARTMENT_LIST_SUCCESS";

export const GET_ALL_DEPARTMENT_LIST_FAILURE =
  "GET_ALL_DEPARTMENT_LIST_FAILURE";

export const POST_DEPARTMENT_REQUEST = "POST_DEPARTMENT_REQUEST";

export const POST_DEPARTMENT_SUCCESS = "POST_DEPARTMENT_SUCCESS";

export const POST_DEPARTMENT_FAILURE = "POST_DEPARTMENT_FAILURE";

export const PUT_DEPARTMENT_REQUEST = "PUT_DEPARTMENT_REQUEST";

export const PUT_DEPARTMENT_SUCCESS = "PUT_DEPARTMENT_SUCCESS";

export const PUT_DEPARTMENT_FAILURE = "PUT_DEPARTMENT_FAILURE";

export const DELETE_DEPARTMENT_REQUEST = "DELETE_DEPARTMENT_REQUEST";

export const DELETE_DEPARTMENT_SUCCESS = "DELETE_DEPARTMENT_SUCCESS";

export const DELETE_DEPARTMENT_FAILURE = "DELETE_DEPARTMENT_FAILURE";

// Departments CATEGORY
export const GET_ALL_DEPARTMENT_CATEGORY_LIST_REQUEST =
  "GET_ALL_DEPARTMENT_CATEGORY_LIST_REQUEST";

export const GET_ALL_DEPARTMENT_CATEGORY_LIST_SUCCESS =
  "GET_ALL_DEPARTMENT_CATEGORY_LIST_SUCCESS";

export const GET_ALL_DEPARTMENT_CATEGORY_LIST_FAILURE =
  "GET_ALL_DEPARTMENT_CATEGORY_LIST_FAILURE";

export const POST_DEPARTMENT_CATEGORY_REQUEST =
  "POST_DEPARTMENT_CATEGORY_REQUEST";

export const POST_DEPARTMENT_CATEGORY_SUCCESS =
  "POST_DEPARTMENT_CATEGORY_SUCCESS";

export const POST_DEPARTMENT_CATEGORY_FAILURE =
  "POST_DEPARTMENT_CATEGORY_FAILURE";

export const PUT_DEPARTMENT_CATEGORY_REQUEST =
  "PUT_DEPARTMENT_CATEGORY_REQUEST";

export const PUT_DEPARTMENT_CATEGORY_SUCCESS =
  "PUT_DEPARTMENT_CATEGORY_SUCCESS";

export const PUT_DEPARTMENT_CATEGORY_FAILURE =
  "PUT_DEPARTMENT_CATEGORY_FAILURE";

export const DELETE_DEPARTMENT_CATEGORY_REQUEST =
  "DELETE_DEPARTMENT_CATEGORY_REQUEST";

export const DELETE_DEPARTMENT_CATEGORY_SUCCESS =
  "DELETE_DEPARTMENT_CATEGORY_SUCCESS";

export const DELETE_DEPARTMENT_CATEGORY_FAILURE =
  "DELETE_DEPARTMENT_CATEGORY_FAILURE";

export const LOGIN_REQUEST = "LOGIN_REQUEST";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_FAILURE = "LOGIN_FAILURE";
export const LOGOUT_REQUEST = "LOGOUT_REQUEST";
export const LOGOUT_SUCCESS = "LOGOUT_SUCCESS";
export const LOGOUT_FAILURE = "LOGOUT_FAILURE";
export const FORGOT_PASSWORD_REQUEST = "FORGOT_PASSWORD_REQUEST";
export const FORGOT_PASSWORD_SUCCESS = "FORGOT_PASSWORD_SUCCESS";
export const FORGOT_PASSWORD_FAILURE = "FORGOT_PASSWORD_FAILURE";
export const VERIFY_OTP_REQUEST = "VERIFY_OTP_REQUEST";
export const VERIFY_OTP_SUCCESS = "VERIFY_OTP_SUCCESS";
export const VERIFY_OTP_FAILURE = "VERIFY_OTP_FAILURE";
export const RESET_PASSWORD_REQUEST = "RESET_PASSWORD_REQUEST";
export const RESET_PASSWORD_SUCCESS = "RESET_PASSWORD_SUCCESS";
export const RESET_PASSWORD_FAILURE = "RESET_PASSWORD_FAILURE";
export const CREATE_USER_REQUEST = "CREATE_USER_REQUEST";
export const CREATE_USER_SUCCESS = "CREATE_USER_SUCCESS";
export const CREATE_USER_FAILURE = "CREATE_USER_FAILURE";
// Departments Inventory
export const GET_ALL_DEPARTMENT_INVENTORY_LIST_REQUEST =
  "GET_ALL_DEPARTMENT_INVENTORY_LIST_REQUEST";

export const GET_ALL_DEPARTMENT_INVENTORY_LIST_SUCCESS =
  "GET_ALL_DEPARTMENT_INVENTORY_LIST_SUCCESS";

export const GET_ALL_DEPARTMENT_INVENTORY_LIST_FAILURE =
  "GET_ALL_DEPARTMENT_INVENTORY_LIST_FAILURE";

export const POST_DEPARTMENT_INVENTORY_REQUEST =
  "POST_DEPARTMENT_INVENTORY_REQUEST";

export const POST_DEPARTMENT_INVENTORY_SUCCESS =
  "POST_DEPARTMENT_INVENTORY_SUCCESS";

export const POST_DEPARTMENT_INVENTORY_FAILURE =
  "POST_DEPARTMENT_INVENTORY_FAILURE";

export const PUT_DEPARTMENT_INVENTORY_REQUEST =
  "PUT_DEPARTMENT_INVENTORY_REQUEST";

export const PUT_DEPARTMENT_INVENTORY_SUCCESS =
  "PUT_DEPARTMENT_INVENTORY_SUCCESS";

export const PUT_DEPARTMENT_INVENTORY_FAILURE =
  "PUT_DEPARTMENT_INVENTORY_FAILURE";

export const DELETE_DEPARTMENT_INVENTORY_REQUEST =
  "DELETE_DEPARTMENT_INVENTORY_REQUEST";

export const DELETE_DEPARTMENT_INVENTORY_SUCCESS =
  "DELETE_DEPARTMENT_INVENTORY_SUCCESS";

export const DELETE_DEPARTMENT_INVENTORY_FAILURE =
  "DELETE_DEPARTMENT_INVENTORY_FAILURE";

// POST_PROCUREMENT_REQUEST
export const POST_PROCUREMENT_REQUEST = "POST_PROCUREMENT_REQUEST";

export const POST_PROCUREMENT_SUCCESS = "POST_PROCUREMENT_SUCCESS";

export const POST_PROCUREMENT_FAILURE = "POST_PROCUREMENT_FAILURE";

export const GET_ALL_PROCUREMENT_LIST_REQUEST =
  "GET_ALL_PROCUREMENT_LIST_REQUEST";

export const GET_ALL_PROCUREMENT_LIST_SUCCESS =
  "GET_ALL_PROCUREMENT_LIST_SUCCESS";

export const GET_ALL_PROCUREMENT_LIST_FAILURE =
  "GET_ALL_PROCUREMENT_LIST_FAILURE";

export const PUT_PROCUREMENT_REQUEST = "PUT_PROCUREMENT_REQUEST";

export const PUT_PROCUREMENT_SUCCESS = "PUT_PROCUREMENT_SUCCESS";

export const PUT_PROCUREMENT_FAILURE = "PUT_PROCUREMENT_FAILURE";

export const DELETE_PROCUREMENT_REQUEST = "DELETE_PROCUREMENT_REQUEST";

export const DELETE_PROCUREMENT_SUCCESS = "DELETE_PROCUREMENT_SUCCESS";

export const DELETE_PROCUREMENT_FAILURE = "DELETE_PROCUREMENT_FAILURE";

export const CANCELLED_ORDER_REQUEST = "CANCELLED_ORDER_REQUEST";
export const CANCELLED_ORDER_SUCCESS = "CANCELLED_ORDER_SUCCESS";
export const CANCELLED_ORDER_FAILURE = "CANCELLED_ORDER_FAILURE";

export const POST_RECORD_PAYMENT_REQUEST = "POST_RECORD_PAYMENT_REQUEST";
export const POST_RECORD_PAYMENT_SUCCESS = "POST_RECORD_PAYMENT_SUCCESS";
export const POST_RECORD_PAYMENT_FAILURE = "POST_RECORD_PAYMENT_REQUEST";

export const GET_OFFICE_REPORTS_REQUEST = "GET_OFFICE_REPORTS_REQUEST";
export const GET_OFFICE_REPORTS_SUCCESS = "GET_OFFICE_REPORTS_SUCCESS";
export const GET_OFFICE_REPORTS_FAILURE = "GET_OFFICE_REPORTS_FAILURE";

export const GET_FINANCIAL_REPORTS_REQUEST = "GET_FINANCIAL_REPORTS_REQUEST";
export const GET_FINANCIAL_REPORTS_SUCCESS = "GET_FINANCIAL_REPORTS_SUCCESS";
export const GET_FINANCIAL_REPORTS_FAILURE = "GET_FINANCIAL_REPORTS_FAILURE";

export const GET_ALL_MAIN_REPORTS_REQUEST = "GET_ALL_MAIN_REPORTS_REQUEST";
export const GET_ALL_MAIN_REPORTS_SUCCESS = "GET_ALL_MAIN_REPORTS_SUCCESS";
export const GET_ALL_MAIN_REPORTS_FAILURE = "GET_ALL_MAIN_REPORTS_FAILURE";

export const GET_ALL_STAFF_LIST_REQUEST = "GET_ALL_STAFF_LIST_REQUEST";
export const GET_ALL_STAFF_LIST_SUCCESS = "GET_ALL_STAFF_LIST_SUCCESS";
export const GET_ALL_STAFF_LIST_FAILURE = "GET_ALL_STAFF_LIST_FAILURE";

export const GET_USER_ACCESS_LIST_REQUEST = "GET_USER_ACCESS_LIST_REQUEST";
export const GET_USER_ACCESS_LIST_SUCCESS = "GET_USER_ACCESS_LIST_SUCCESS";
export const GET_USER_ACCESS_LIST_FAILURE = "GET_USER_ACCESS_LIST_FAILURE";

export const UPDATE_USER_ACCESS_REQUEST = "UPDATE_USER_ACCESS_REQUEST";
export const UPDATE_USER_ACCESS_SUCCESS = "UPDATE_USER_ACCESS_SUCCESS";
export const UPDATE_USER_ACCESS_FAILURE = "UPDATE_USER_ACCESS_FAILURE";

export const GET_DEFAULT_ACCESS_REQUEST = "GET_DEFAULT_ACCESS_REQUEST";
export const GET_DEFAULT_ACCESS_SUCCESS = "GET_DEFAULT_ACCESS_SUCCESS";
export const GET_DEFAULT_ACCESS_FAILURE = "GET_DEFAULT_ACCESS_FAILURE";

export const GET_ROOM_LIST_REQUEST = "GET_ROOM_LIST_REQUEST";
export const GET_ROOM_LIST_SUCCESS = "GET_ROOM_LIST_SUCCESS";
export const GET_ROOM_LIST_FAILURE = "GET_ROOM_LIST_FAILURE";

export const GET_PAYMENT_METHODS_REPORT_REQUEST = "GET_PAYMENT_METHODS_REPORT_REQUEST";
export const GET_PAYMENT_METHODS_REPORT_SUCCESS = "GET_PAYMENT_METHODS_REPORT_SUCCESS";
export const GET_PAYMENT_METHODS_REPORT_FAILURE = "GET_PAYMENT_METHODS_REPORT_FAILURE";

export const GET_RECENT_NOTIFICATIONS_REQUEST = "GET_RECENT_NOTIFICATIONS_REQUEST";
export const GET_RECENT_NOTIFICATIONS_SUCCESS = "GET_RECENT_NOTIFICATIONS_SUCCESS";
export const GET_RECENT_NOTIFICATIONS_FAILURE = "GET_RECENT_NOTIFICATIONS_FAILURE";

export const RESET_BOOKING_SUCCESS = 'RESET_BOOKING_SUCCESS';
